export default "__VITE_ASSET__BlKnXHrS__"